module.exports = __webpack_public_path__ + "media/icons/drzwi-3738017e.png";